<template>
	<vx-card>
		<form-wizard
			v-if="OptimizationCreatePermission"
			id="wizard-with-loading-optimization"
			ref="WizardShipment"
			class="vs-con-loading__container"
			color="rgba(var(--vs-primary), 1)"
			errorColor="rgba(var(--vs-danger), 1)"
			stepSize="sm"
			shape="circle"
			:subtitle="null"
			:finishButton="false"
			:finishButtonText="$t('ResourceModule.Create.Save')"
			:backButtonText="$t('ResourceModule.Create.Back')"
			:nextButtonText="$t('ResourceModule.Create.Next')"
		>
			<template slot="title">
				<div class="floating-buttons-container">
					<div class="buttons-left">
						<floating-buttons-wizard
							:backText="$t('ResourceModule.Create.Back')"
							:cancelText="$t('Cancel')"
							:saveText="
								$refs.WizardShipment &&
								!$refs.WizardShipment.isLastStep &&
								$refs.WizardShipment.activeTabIndex <= 1
									? $t('ResourceModule.Create.Next')
									: $t('Routing.Buttons.Optimize')
							"
							:canGoBack="$refs.WizardShipment && $refs.WizardShipment.activeTabIndex > 0"
							:disabledSave="nextButtonDisabled"
							@back="validateBack"
							@cancel="$router.push({name: 'OptimizationList'})"
							@save="showPrompt"
						/>
					</div>
				</div>
			</template>
			<tab-content
				icon="feather icon-map-pin"
				:title="$t('Routing.Title.VisitPoints')"
				:before-change="validateStep1"
			>
				<optimization-top-tabs
					:currentTab="activeTabLabel"
					@go="handleTopTabChange"
					class="enhanced-internal-tabs optimization-top-tabs"
				>
					<template v-slot="{currentTab}">
						<div class="vx-row">
							<div class="vx-col w-full" :class="maximize || activeTab === 2 ? 'md:w-4/4' : 'md:w-3/5'">
								<div v-if="currentTab === 'Serviroutes'">
									<visit-point-list-optimization
										v-show="isMounted"
										ref="visitPointListServiroute"
										:customConfig="visitPointListConfig"
										:status_id="status_id"
										:maximize="maximize"
										:circleList="circleList"
										:polygonList="polygonList"
										:typeSelected="shapeSelected ? shapeSelected.type : ''"
										@handleMaximize="handleMaximize"
										@showSelectedVisitsPointEmit="showSelectedVisitsPoint"
										@gridApiEmit="getGridApi"
										@getModeSelectedEmit="getModeSelected"
										@getVisitPointsInMapEmit="loadAndDisplayVisitPoints"
										@mountedVisitPointList="getMountedVisitPointList"
									/>
								</div>
								<div v-else-if="currentTab === 'Datarutas'">
									<div v-if="isDatarutasEnabled">
										<visit-point-list-datarutas
											v-show="isMounted"
											ref="visitPointListDataruta"
											:customConfig="visitPointListConfigDatarutas"
											:status_id="status_id"
											:maximize="maximize"
											:circleList="circleList"
											:polygonList="polygonList"
											:typeSelected="shapeSelected ? shapeSelected.type : ''"
											@handleMaximize="handleMaximize"
											@showSelectedVisitsPointEmit="showSelectedVisitsPoint"
											@gridApiDatarutasEmit="getGridApi"
											@getModeSelectedEmit="getModeSelected"
											@getVisitPointsInMapDatarutasEmit="loadAndDisplayVisitPoints"
										/>
									</div>
									<not-authorized
										v-else
										:subTitle="$t('NotAuthorizedPage.SubtitleDatarutas')"
										:login="loginDatarutas"
									></not-authorized>
								</div>
								<div v-else-if="currentTab === 'Upload'">
									<upload-file
										ref="uploadFilevisitPointList"
										:inputFileId="'inputUploadFilevisitPointList'"
										:inputFileIcon="'MapPinIcon'"
										:typeUploadFile="'VISIT_POINT_UPLOAD'"
										:activateListUploadFile="true"
										:showUploadFileOptimization="showUploadFileOptimization"
										:showSetEquivalenceOptimization="showSetEquivalenceOptimization"
										@dataFileEmit="getDataFile"
										@setUploadFileOptimization="setUploadFileOptimization"
										@setEquivalenceOptimization="setEquivalenceOptimization"
										@disableNextButton="handleDisableNextButton"
									/>
								</div>
							</div>
							<div
								id="google-map-loading"
								class="vx-col w-full md:w-2/5 vs-con-loading__container"
								v-show="!maximize && activeTab != 2"
							>
								<drawing-tools
									:showBtnDeleteShape="showBtnDeleteShape"
									style="background: none"
									@deleteShapeEmit="deleteShape"
								></drawing-tools>
								<vs-button
									class="btn-hiden-map"
									style="
										color: rgb(51, 49, 49);
										border-radius: 2px;
										position: absolute;
										z-index: 1;
										top: 130px;
										right: 25px;
										box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
									"
									color="white"
									type="filled"
									icon="location_off"
									:title="$t('Routing.Map.HideMap')"
									@click.prevent="handleMaximize"
								></vs-button>
								<transition name="fade">
									<google-maps
										v-if="isMounted && renderMountedVpsr"
										id="map-content-optimization"
										name="map-iot"
										latitude="4.686699"
										longitude="-74.0837187"
										zoom="13"
										theme="uber"
										ref="moduleMap"
										calledFrom="optimization"
									></google-maps>
								</transition>
								<vs-prompt
									:title="$t('TypeOfService')"
									:cancel-text="$t('Cancel')"
									:accept-text="$t('Accept')"
									:active.sync="activePromptCheck"
									:is-valid="is_pickup === true || is_delivery === true"
									@cancel="closePromptCheck"
									@accept="acceptAlertCheck"
									@close="closePromptCheck"
								>
									<div>
										<label>{{ $t("SpecifyTheTypeOfServiceForTheSelectedVisitPoints") }}</label>
										<ul class="centerx flex items-center justify-evenly mt-4">
											<li>
												<vs-checkbox v-model="is_pickup">{{ $t("PICKUP") }}</vs-checkbox>
											</li>
											<li>
												<vs-checkbox v-model="is_delivery">{{ $t("DELIVERY") }}</vs-checkbox>
											</li>
										</ul>
									</div>
								</vs-prompt>
							</div>
						</div>
					</template>
				</optimization-top-tabs>
			</tab-content>
			<tab-content icon="feather icon-truck" :title="$t('Vehicles.Vehicles')" :before-change="validateStep2">
				<optimization-top-tabs
					:currentTab="activeTabLabel"
					@go="handleTopTabChange"
					class="enhanced-internal-tabs"
				>
					<template v-slot="{currentTab}">
						<div class="vx-row">
							<div class="vx-col w-full">
								<div v-if="currentTab === 'Serviroutes'">
									<vehicle-list
										ref="VehicleList"
										:componentParent="'OPTIMIZATION'"
										:customConfig="vehicleListConfig"
										:pagination="paginationVehicles"
									/>
								</div>
								<div v-else-if="currentTab === 'Datarutas'">
									<div v-if="isDatarutasEnabled">
										<resource-list-datarutas
											v-show="isMounted"
											ref="ResourceListDatarutas"
											:customConfig="vehicleListConfigDatarutas"
											:pagination="paginationResourceDatarutas"
											:componentParent="'OPTIMIZATION'"
										/>
									</div>
									<not-authorized
										v-else
										:subTitle="$t('NotAuthorizedPage.SubtitleResourceDatarutas')"
										:login="loginDatarutas"
									></not-authorized>
								</div>
								<div v-else-if="currentTab === 'Upload'">
									<upload-file
										ref="uploadVehicleList"
										:inputFileId="'inputUploadFileVehicleList'"
										:inputFileIcon="'TruckIcon'"
										:typeUploadFile="'VEHICLE_UPLOAD'"
										:activateListUploadFile="true"
										:showUploadFileOptimization="showUploadFileOptimization"
										:showSetEquivalenceOptimization="showSetEquivalenceOptimization"
										@dataFileEmit="getDataFile"
										@setUploadFileOptimization="setUploadFileOptimization"
										@setEquivalenceOptimization="setEquivalenceOptimization"
										@disableNextButton="handleDisableNextButton"
									/>
								</div>
							</div>
						</div>
					</template>
				</optimization-top-tabs>
			</tab-content>
			<tab-content icon="feather icon-file-text" :title="$t('VisitPoints.SelectedInformation')">
				<vs-navbar :type="'gradient'" v-model="activeItem" class="nabarx mt-base mb-4 enhanced-internal-tabs">
					<div slot="title">
						<vs-navbar-title class="flex items-cemter">
							<span class="text-primary font-bold ml-4 mt-2">{{ getNameOptimization }} </span>
						</vs-navbar-title>
					</div>
					<vs-navbar-item index="0">
						<a href="#" class="text-center"
							><feather-icon class="cursor-pointer" icon="MapPinIcon" /><br /><small
								style="font-size: 0.9rem"
								class="font-semibold"
								>{{
									activeItem === "0"
										? $t("RouterSelection.VisitPoints")
										: $t("See") + " " + $t("RouterSelection.VisitPoints")
								}}</small
							></a
						>
					</vs-navbar-item>
					<vs-navbar-item index="1">
						<a href="#" class="text-center"
							><feather-icon class="cursor-pointer" icon="TruckIcon" /><br /><small
								style="font-size: 0.9rem"
								class="font-semibold"
								>{{
									activeItem === "1"
										? $t("Vehicles.Vehicles")
										: $t("See") + " " + $t("Vehicles.Vehicles")
								}}</small
							></a
						>
					</vs-navbar-item>
					<vs-navbar-item index="2">
						<a href="#" class="text-center"
							><feather-icon class="cursor-pointer" icon="LinkIcon" /><br /><small
								style="font-size: 0.9rem"
								class="font-semibold"
								>{{
									activeItem === "2"
										? $t("Jobs.JobPlanning")
										: $t("See") + " " + $t("Jobs.JobPlanning")
								}}</small
							></a
						>
					</vs-navbar-item>
				</vs-navbar>
				<transition name="fade">
					<ListSelectedVisitPoints
						v-if="activeItem === '0' && activeTabVisitPoint"
						ref="ListSelectedVisitPoint"
						:activeTabVisitPoint="activeTabVisitPoint"
					/>
				</transition>
				<transition name="fade">
					<list-select-vehicle v-if="activeItem === '1' && activeTabResource" ref="ListSelectedVehicle" />
				</transition>
				<transition name="fade">
					<job-planning-form v-if="activeItem === '2'" />
				</transition>
				<vs-prompt
					class="prompt-content"
					:title="$t('Optimization.CreateOptimization')"
					:active.sync="activePrompt"
					:acceptText="$t('Accept')"
					:cancelText="$t('Cancel')"
					:is-valid="validFormPrompt"
					@cancel="closePrompt"
					@accept="acceptPrompt"
					@close="closePrompt"
				>
					<optimization-create
						:optimizationObject="dataOptimization"
						@OptimizationFields="optimizationFields"
					/>
				</vs-prompt>
				<vs-prompt
					class="prompt-content"
					:title="$t('Frequency.DiscardedItems.Title')"
					:active.sync="activeDiscardedItemsPrompt"
					:cancelText="$t('Routing.Title.Close')"
					:buttons-hidden="true"
					@cancel="closeDiscardedItemsPrompt"
					@close="closeDiscardedItemsPrompt"
				>
					<div class="text-left">
						<p>{{ $t("Frequency.DiscardedItems.Message") }}</p>
						<ul class="mt-2 mb-10 pl-4">
							<li v-for="(item, index) in paginatedDiscardedItems" :key="index" class="mb-2">
								❌ {{ item }}
							</li>
						</ul>
						<!-- Pagination -->
						<div v-if="showDiscardedItemsPagination" class="mt-2 mb-10 text-center">
							<vs-pagination
								:total="totalDiscardedItemsPages"
								:max="5"
								v-model="currentDiscardedItemsPage"
								@change="changeDiscardedItemsPage"
							/>
						</div>
					</div>
				</vs-prompt>
				<optimization-errors
					:errorsActive="errorsActive"
					:optimizationErrors="optimizationErrors"
					@activePopupEmit="activePopup"
				/>
			</tab-content>
		</form-wizard>
		<not-permission v-else></not-permission>

		<!-- Floating Action Button for Period Configuration -->
		<div class="config-period-fab flex items-center justify-center gap-2">
			<!-- Warning Icon for Discarded Items -->
			<vs-button
				v-if="discardedItemsList.length > 0"
				color="warning"
				type="filled"
				size="small"
				class="warning-discarded-items-btn flex items-center justify-center"
				:title="$t('Frequency.DiscardedItems.Title')"
				@click="activeDiscardedItemsPrompt = true"
			>
				<div class="flex items-center justify-center">
					<feather-icon icon="AlertTriangleIcon" class="mr-2" />
					{{ discardedItemsList.length }} {{ $t("Frequency.DiscardedItems.items") }}
				</div>
			</vs-button>
			<vs-button
				color="primary"
				type="filled"
				size="small"
				@click="showOptimizationPeriodPopup = true"
				class="config-period-fab-btn flex items-center justify-center"
				:title="$t('Optimization.ConfigurePeriod')"
			>
				<div class="flex items-center justify-center">
					<feather-icon icon="SettingsIcon" class="mr-2" />
					{{ $t("Optimization.ConfigurePeriod") }}
				</div>
			</vs-button>
		</div>

		<!-- Optimization Period Configuration Popup -->
		<vs-prompt
			:title="$t('Optimization.OptimizationPeriod')"
			:active.sync="showOptimizationPeriodPopup"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			:is-valid="isOptimizationPeriodValid"
			@cancel="closeOptimizationPeriodPopup"
			@accept="saveOptimizationPeriod"
			@close="closeOptimizationPeriodPopup"
			class="optimization-period-popup"
		>
			<div class="optimization-period-form">
				<div class="vx-row">
					<div class="vx-col w-full md:w-1/2 sm:w-1/1 text-left">
						<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
						<datepicker
							:language="$vs.rtl ? langHe : langEn"
							name="popupInitDate"
							v-validate="'validatorInitDate'"
							v-model="init_date"
							class="w-full"
						></datepicker>
						<span class="text-danger text-sm" v-show="errors.has('popupInitDate')">{{
							$t("BreakForm.ErrorMessages.DateInitError")
						}}</span>
					</div>
					<div class="vx-col w-full md:w-1/2 sm:w-1/1 text-left">
						<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
						<datepicker
							:language="$vs.rtl ? langHe : langEn"
							v-validate="'validatorEndDate'"
							name="popupEndDate"
							v-model="end_date"
							class="w-full"
						></datepicker>
						<span class="text-danger text-sm" v-show="errors.has('popupEndDate')">{{
							$t("BreakForm.ErrorMessages.DateInitError")
						}}</span>
					</div>
				</div>
				<div class="vx-row mt-4">
					<div class="vx-col w-full md:w-1/2 sm:w-1/1 text-left">
						<small class="date-label">{{ $t("Routing.Table.InitHour") }}</small>
						<flat-pickr
							:config="configdateTimePicker"
							class="w-full"
							v-model="init_hour"
							v-validate="'validatorInitHour'"
							name="popupDataHourInit"
						/>
						<span class="text-danger text-sm" v-show="errors.has('popupDataHourInit')">{{
							$t("BreakForm.ErrorMessages.ValidInitHour")
						}}</span>
					</div>
					<div class="vx-col w-full md:w-1/2 sm:w-1/1 text-left">
						<small class="date-label">{{ $t("Routing.Table.EndHour") }}</small>
						<flat-pickr
							:config="configdateTimePicker"
							v-model="end_hour"
							class="w-full"
							v-validate="'validatorEndHour'"
							name="popupDataHourEnd"
						/>
						<span class="text-danger text-sm" v-show="errors.has('popupDataHourEnd')">{{
							$t("BreakForm.ErrorMessages.ValidEndHour")
						}}</span>
					</div>
				</div>
			</div>
		</vs-prompt>
	</vx-card>
</template>
<script>
import {OptimizationMixin} from "../optimization/model/OptimizationMixin";

export default {
	mixins: [OptimizationMixin],
	data() {
		return {
			showOptimizationPeriodPopup: false,
			nextButtonDisabled: false,
		};
	},
	computed: {
		isOptimizationPeriodValid() {
			// Puedes personalizar la validación según tus necesidades
			return !!this.init_date && !!this.end_date && !!this.init_hour && !!this.end_hour;
		},
	},
	methods: {
		closeOptimizationPeriodPopup() {
			this.showOptimizationPeriodPopup = false;
		},
		saveOptimizationPeriod() {
			// Aquí puedes guardar los datos o hacer lo que necesites
			this.showOptimizationPeriodPopup = false;
			// Opcional: mostrar notificación de éxito
		},
		handleDisableNextButton(disabled) {
			this.nextButtonDisabled = disabled;
		},
	},
};
</script>
<style lang="scss">
.vs-con-loading__container .vue-form-wizard {
	padding-bottom: 0 !important;
	.wizard-tab-content {
		padding: 10px 0 0 0 !important;
		.wizard-tab-container {
			padding: 10px 0 0 0 !important;
		}
	}
}
.btn-hiden-map {
	.material-icons {
		font-size: 24px;
	}
}
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}
.vue-form-wizard .wizard-header {
	padding: 0px !important;
}
#map-content-optimization {
	.gm-ui-hover-effect {
		display: none !important;
	}
	.custom-info-window {
		padding: 10px;
		background-color: white;
		border: 1px solid #ccc;
		border-radius: 4px;
	}
}
#wizard-with-loading-optimization .wizard-card-footer {
	display: none !important;
}
#google-map-loading {
	.con-vs-loading {
		z-index: 9999 !important;
	}
}
</style>
<style lang="scss" scoped>
/* Optimization Period Popup Styles */
.optimization-period-popup {
	.vs-prompt__content {
		max-width: 600px;
		width: 90vw;
	}

	.optimization-period-form {
		padding: 20px 0;

		.date-label {
			display: block;
			font-size: 0.85rem;
			font-weight: 600;
			color: #495057;
			margin-bottom: 8px;
			text-transform: uppercase;
			letter-spacing: 0.5px;
		}

		.vx-row {
			margin: 0 -10px;

			.vx-col {
				padding: 0 10px;
				margin-bottom: 16px;
			}
		}

		.vx-input {
			margin-bottom: 8px;
		}

		.text-danger {
			font-size: 0.75rem;
			margin-top: 4px;
			display: block;
		}
	}
}

/* Responsive adjustments for the floating buttons */
@media (max-width: 768px) {
	.floating-buttons-container {
		flex-direction: column;
		gap: 12px;

		.buttons-left {
			width: 100%;
		}
	}

	.config-period-fab {
		top: 70px;
		right: 15px;

		.config-period-fab-btn {
			font-size: 0.8rem;

			.feather-icon {
				width: 14px;
				height: 14px;
			}
		}
	}

	.optimization-period-popup {
		.vs-prompt__content {
			width: 95vw;
			margin: 10px;
		}

		.optimization-period-form {
			.vx-row {
				.vx-col {
					width: 100% !important;
				}
			}
		}
	}
}

@media (max-width: 480px) {
	.config-period-fab {
		top: 60px;
		right: 10px;

		.config-period-fab-btn {
			font-size: 0.75rem;

			.feather-icon {
				width: 12px;
				height: 12px;
			}
		}
	}
}

/* Enhanced Wizard Progress Indicator */
.wizard-progress-container {
	position: relative;
	margin: 20px 0;
	padding: 0 30px;

	.progress-bar {
		height: 6px;
		background: linear-gradient(90deg, #e9ecef 0%, #dee2e6 50%, #e9ecef 100%);
		border-radius: 3px;
		position: relative;
		overflow: hidden;

		.progress-fill {
			height: 100%;
			background: linear-gradient(90deg, rgba(var(--vs-primary), 1) 0%, rgba(var(--vs-primary), 0.8) 100%);
			border-radius: 3px;
			transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
			position: relative;

			&::after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%);
				animation: shimmer 2s infinite;
			}
		}
	}

	.progress-steps {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;

		.step-indicator {
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 0.75rem;
			color: #6c757d;
			transition: all 0.3s ease;

			&.completed {
				color: #28a745;
				font-weight: 600;
			}

			&.active {
				color: rgba(var(--vs-primary), 1);
				font-weight: 700;
			}
		}
	}
}

@keyframes shimmer {
	0% {
		transform: translateX(-100%);
	}
	100% {
		transform: translateX(100%);
	}
}

/* Enhanced Step Status Indicators */
.step-status {
	position: absolute;
	top: -5px;
	right: -5px;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	font-weight: bold;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
	z-index: 10;

	&.completed {
		background: #28a745;
		color: white;
		animation: pulse 2s infinite;
	}

	&.active {
		background: rgba(var(--vs-primary), 1);
		color: white;
		animation: bounce 1s infinite;
	}

	&.pending {
		background: #6c757d;
		color: white;
	}
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
}

@keyframes bounce {
	0%,
	20%,
	50%,
	80%,
	100% {
		transform: translateY(0);
	}
	40% {
		transform: translateY(-3px);
	}
	60% {
		transform: translateY(-2px);
	}
}

/* Floating Action Button for Period Configuration */
.config-period-fab {
	position: absolute;
	top: -55px;
	right: 10px;
	z-index: 1000;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

	.config-period-fab-btn {
		background: linear-gradient(135deg, rgba(var(--vs-primary), 1) 0%, rgba(var(--vs-primary), 0.9) 100%);
		border: none;
		border-radius: 50px;
		font-weight: 600;
		font-size: 0.9rem;
		box-shadow: 0 4px 20px rgba(var(--vs-primary), 0.3);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		backdrop-filter: blur(10px);

		&:hover {
			transform: translateY(-2px) scale(1.05);
			box-shadow: 0 8px 25px rgba(var(--vs-primary), 0.4);
			background: linear-gradient(135deg, rgba(var(--vs-primary), 0.9) 0%, rgba(var(--vs-primary), 1) 100%);
		}

		&:active {
			transform: translateY(0) scale(1);
		}

		.feather-icon {
			width: 16px;
			height: 16px;
		}

		/* Pulse animation on hover */
		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			border-radius: 50px;
			background: rgba(var(--vs-primary), 0.2);
			opacity: 0;
			transition: opacity 0.3s ease;
		}

		&:hover::before {
			opacity: 1;
			animation: pulse 2s infinite;
		}
	}

	/* Warning Button for Discarded Items */
	.warning-discarded-items-btn {
		background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
		border: none;
		border-radius: 50px;
		font-weight: 600;
		font-size: 0.9rem;
		box-shadow: 0 4px 20px rgba(255, 193, 7, 0.3);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		backdrop-filter: blur(10px);
		position: relative;
		overflow: hidden;

		&:hover {
			transform: translateY(-2px) scale(1.05);
			box-shadow: 0 8px 25px rgba(255, 193, 7, 0.4);
			background: linear-gradient(135deg, #ff9800 0%, #ffc107 100%);
			animation: shake 0.5s ease-in-out;
		}

		&:active {
			transform: translateY(0) scale(1);
		}

		.feather-icon {
			width: 16px;
			height: 16px;
		}

		/* Pulse animation on hover */
		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			border-radius: 50px;
			background: rgba(255, 193, 7, 0.2);
			opacity: 0;
			transition: opacity 0.3s ease;
		}

		&:hover::before {
			opacity: 1;
			animation: warningPulse 2s infinite;
		}
	}
}

@keyframes pulse {
	0% {
		transform: scale(1);
		opacity: 0.8;
	}
	50% {
		transform: scale(1.1);
		opacity: 0.4;
	}
	100% {
		transform: scale(1);
		opacity: 0.8;
	}
}

@keyframes warningPulse {
	0%,
	100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
}

@keyframes shake {
	0%,
	100% {
		transform: translateX(0);
	}
	20%,
	60% {
		transform: translateX(-6px);
	}
	40%,
	80% {
		transform: translateX(6px);
	}
}

/* Enhanced Floating Buttons with Progress Context */
.floating-buttons-container {
	background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
	border: 1px solid #dee2e6;
	border-radius: 8px;
	padding: 8px;
	margin-bottom: 10px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 4px;
		height: 100%;
		background: linear-gradient(180deg, rgba(var(--vs-primary), 1) 0%, rgba(var(--vs-primary), 0.7) 100%);
		border-radius: 0 2px 2px 0;
	}

	.buttons-left {
		flex: 1;
	}

	.progress-info {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 8px;
		padding: 0 8px;

		.step-counter {
			font-size: 0.8rem;
			color: #6c757d;
			font-weight: 500;
		}

		.completion-status {
			font-size: 0.75rem;
			color: #28a745;
			font-weight: 600;
		}
	}

	.vs-button {
		margin: 0 4px;
		border-radius: 6px;
		font-weight: 500;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;

		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: -100%;
			width: 100%;
			height: 100%;
			background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.2) 50%, transparent 100%);
			transition: left 0.5s ease;
		}

		&:hover::before {
			left: 100%;
		}

		&:hover {
			transform: translateY(-1px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		}

		&:active {
			transform: translateY(0);
		}
	}
}

/* Enhanced Section Headers */
.step-section-header {
	background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
	border: 1px solid #dee2e6;
	border-radius: 8px;
	padding: 20px;
	margin-bottom: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	position: relative;
	overflow: hidden;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 4px;
		height: 100%;
		background: linear-gradient(180deg, rgba(var(--vs-primary), 1) 0%, rgba(var(--vs-primary), 0.7) 100%);
	}

	.section-title-wrapper {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
		gap: 12px;

		.section-icon {
			width: 24px;
			height: 24px;
			color: rgba(var(--vs-primary), 1);
			flex-shrink: 0;
		}

		.section-title {
			font-size: 1.25rem;
			font-weight: 600;
			color: #2c3e50;
			margin: 0;
			flex-grow: 1;
		}

		.section-badge {
			font-size: 0.75rem;
			font-weight: 500;
			padding: 4px 8px;
			border-radius: 12px;
			background: rgba(var(--vs-primary), 0.1);
			color: rgba(var(--vs-primary), 1);
			border: 1px solid rgba(var(--vs-primary), 0.2);
		}
	}

	.section-description {
		color: #6c757d;
		font-size: 0.9rem;
		margin: 0;
		line-height: 1.4;
	}
}

/* Responsive improvements */
@media (max-width: 768px) {
	.step-section-header {
		padding: 16px;
		margin-bottom: 16px;

		.section-title-wrapper {
			flex-direction: column;
			align-items: flex-start;
			gap: 8px;

			.section-title {
				font-size: 1.1rem;
			}
		}
	}

	.enhanced-internal-tabs {
		position: static !important;
		.vs-tabs--ul .vs-tabs--li .vs-tabs--btn {
			padding: 12px 16px;
			font-size: 0.9rem;
		}

		&.nabarx .vs-navbar-item a {
			padding: 12px 16px;
			font-size: 0.9rem;
		}
	}
}

/* Animation for tab transitions */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

/* Enhanced focus states for accessibility */
.enhanced-internal-tabs {
	.vs-tabs--btn:focus,
	.vs-navbar-item a:focus {
		outline: 2px solid rgba(var(--vs-primary), 0.5);
		outline-offset: 2px;
	}
}

/* Enhanced Wizard Tabs Styling */
.vue-form-wizard {
	.wizard-header {
		padding: 0px !important;
		background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
		border-radius: 12px 12px 0 0;
		border: 1px solid #dee2e6;
		border-bottom: none;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.wizard-nav-pills {
		display: flex;
		justify-content: space-between;
		padding: 20px 30px;
		gap: 15px;
		position: relative;

		&::before {
			content: "";
			position: absolute;
			top: 50%;
			left: 30px;
			right: 30px;
			height: 3px;
			background: linear-gradient(90deg, #e9ecef 0%, #dee2e6 50%, #e9ecef 100%);
			border-radius: 2px;
			transform: translateY(-50%);
			z-index: 1;
		}

		li {
			position: relative;
			z-index: 2;
			flex: 1;
			max-width: 200px;

			.wizard-nav-link {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 20px 16px;
				background: white;
				border: 2px solid #e9ecef;
				border-radius: 12px;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
				transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
				position: relative;
				overflow: hidden;
				min-height: 100px;
				justify-content: center;

				&::before {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					height: 4px;
					background: linear-gradient(
						90deg,
						rgba(var(--vs-primary), 1) 0%,
						rgba(var(--vs-primary), 0.7) 100%
					);
					transform: scaleX(0);
					transition: transform 0.3s ease;
				}

				.wizard-icon {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					background: #f8f9fa;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-bottom: 12px;
					transition: all 0.3s ease;
					border: 2px solid #e9ecef;
					position: relative;
					z-index: 1;

					i {
						font-size: 18px;
						color: #6c757d;
						transition: all 0.3s ease;
					}
				}

				/* Enhanced Main Tab Title - Make it more prominent */
				.wizard-title {
					font-size: 1.1rem !important;
					font-weight: 900 !important;
					color: #2c3e50 !important;
					text-transform: uppercase;
					letter-spacing: 0.5px;
					text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
					position: relative;

					&::after {
						content: "";
						position: absolute;
						bottom: -4px;
						left: 50%;
						transform: translateX(-50%);
						width: 30px;
						height: 3px;
						background: linear-gradient(
							90deg,
							rgba(var(--vs-primary), 1) 0%,
							rgba(var(--vs-primary), 0.7) 100%
						);
						border-radius: 2px;
						opacity: 0;
						transition: opacity 0.3s ease;
					}
				}

				/* Hover Effects */
				&:hover {
					transform: translateY(-4px);
					box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
					border-color: rgba(var(--vs-primary), 0.3);

					.wizard-icon {
						background: rgba(var(--vs-primary), 0.1);
						border-color: rgba(var(--vs-primary), 0.3);

						i {
							color: rgba(var(--vs-primary), 1);
						}
					}

					.wizard-title {
						color: rgba(var(--vs-primary), 1);
					}
				}

				/* Active State */
				&.active {
					background: linear-gradient(
						135deg,
						rgba(var(--vs-primary), 0.05) 0%,
						rgba(var(--vs-primary), 0.02) 100%
					);
					border-color: rgba(var(--vs-primary), 1);
					box-shadow: 0 8px 25px rgba(var(--vs-primary), 0.2);
					transform: translateY(-2px);

					&::before {
						transform: scaleX(1);
					}

					.wizard-icon {
						background: rgba(var(--vs-primary), 1);
						border-color: rgba(var(--vs-primary), 1);
						box-shadow: 0 4px 12px rgba(var(--vs-primary), 0.3);

						i {
							color: white;
						}
					}

					.wizard-title {
						color: rgba(var(--vs-primary), 1);
						font-weight: 900;
					}
				}

				/* Completed State */
				&.done {
					background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
					border-color: #28a745;
					box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);

					.wizard-icon {
						background: #28a745;
						border-color: #28a745;

						i {
							color: white;
						}
					}

					.wizard-title {
						color: #155724;
						font-weight: 800;
					}

					&::after {
						content: "✓";
						position: absolute;
						top: 8px;
						right: 8px;
						width: 20px;
						height: 20px;
						background: #28a745;
						color: white;
						border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 12px;
						font-weight: bold;
					}
				}

				/* Disabled State */
				&.disabled {
					opacity: 0.6;
					cursor: not-allowed;
					background: #f8f9fa;

					&:hover {
						transform: none;
						box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
					}

					.wizard-icon {
						background: #e9ecef;
						border-color: #dee2e6;

						i {
							color: #adb5bd;
						}
					}

					.wizard-title {
						color: #adb5bd;
					}
				}
			}
		}
	}

	/* Progress Indicator */
	.wizard-progress {
		position: absolute;
		top: 50%;
		left: 30px;
		right: 30px;
		height: 3px;
		background: linear-gradient(90deg, rgba(var(--vs-primary), 1) 0%, rgba(var(--vs-primary), 0.7) 100%);
		border-radius: 2px;
		transform: translateY(-50%);
		z-index: 1;
		transition: all 0.4s ease;
	}

	/* Step Numbers */
	.wizard-step-number {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 24px;
		height: 24px;
		background: rgba(var(--vs-primary), 1);
		color: white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: bold;
		box-shadow: 0 2px 8px rgba(var(--vs-primary), 0.3);
	}
}

/* Responsive Design for Wizard Tabs */
@media (max-width: 768px) {
	.vue-form-wizard {
		.wizard-nav-pills {
			flex-direction: column;
			padding: 15px 20px;
			gap: 10px;

			&::before {
				display: none;
			}

			li {
				max-width: none;

				.wizard-nav-link {
					flex-direction: row;
					padding: 15px;
					min-height: auto;
					text-align: left;

					.wizard-icon {
						margin-bottom: 0;
						margin-right: 12px;
						width: 35px;
						height: 35px;

						i {
							font-size: 16px;
						}
					}

					.wizard-title {
						text-align: left;
						font-size: 0.85rem;
					}
				}
			}
		}
	}
}

@media (max-width: 480px) {
	.vue-form-wizard {
		.wizard-nav-pills {
			padding: 10px 15px;

			li .wizard-nav-link {
				padding: 12px;

				.wizard-icon {
					width: 30px;
					height: 30px;
					margin-right: 10px;

					i {
						font-size: 14px;
					}
				}

				.wizard-title {
					font-size: 0.8rem;
				}
			}
		}
	}
}

/* Animation for tab transitions */
.wizard-nav-link {
	animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* Focus states for accessibility */
.wizard-nav-link:focus {
	outline: 2px solid rgba(var(--vs-primary), 0.5);
	outline-offset: 2px;
}
</style>
